import { z } from 'zod';

export const ConsultationSchema = z.object({
    id: z.string(),
    pregnancyId: z.string().optional(),
    professionalId: z.string().optional(),
    /**
     * Marca da sessão em que o registro aconteceu (A052, fase 2). Opcional
     * enquanto o dado antigo é backfillado; a leitura passa a filtrar por ele
     * na fase 3. Cada CRM vê só o que aconteceu na própria marca.
     */
    brandId: z.string().nullable().optional(),
    date: z.coerce.date(),

    // Snapshot da idade gestacional naquele momento
    gestationalAge: z.object({
        weeks: z.number().int().min(0).max(45),
        days: z.number().int().min(0).max(6),
    }).optional().nullable(),

    // Dados vitais
    weightKg: z.number().positive().optional(),
    bloodPressure: z.object({
        systolic: z.number().int().positive(),
        diastolic: z.number().int().positive(),
    }).optional(),

    // Dados obstétricos
    fundalHeightCm: z.number().positive().optional(),
    fetalHeartRate: z.number().int().positive().optional(),
    fetalMovement: z.boolean().optional(),

    // Anotações gerais
    notes: z.string().optional(),

    // Medições registradas nesta consulta (lista de tipos)
    recordedMeasurements: z.array(z.string()).optional(),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export type Consultation = z.infer<typeof ConsultationSchema>;
